import React, { useState, useEffect } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Box, Card, makeStyles, Container, CardHeader, CardContent, Divider, MenuItem, Grid, InputLabel, TextField, Button, Typography, Checkbox, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { useNavigate } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker } from "@material-ui/pickers";
import { Formik } from 'formik';
import * as Yup from "yup";
import { LoadingComponent } from 'src/utils/newLoader';
import xlsx from 'json-as-xlsx';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    },
}));

var screenCode = "INVOICEPAYMENT"

export default function InvoicePaymentListing() {
    const classes = useStyles();
    const [groups, setGroups] = useState();
    const [factories, setFactories] = useState();
    const [gridArray, setGridArray] = useState([]);
    const [paymentIDData, setpaymentIDdata] = useState(null);
    const [suppliersAuto, setSuppliersAuto] = useState();
    const [generalJournalList, setGeneralJournalList] = useState({
        groupID: 0,
        factoryID: 0,
        supplierID: 0,
        payableModeID: 0,
        transactionTypeID: 0,
        fromDate: new Date(),
        toDate: new Date()
    })
    const [suppliers, setSuppliers] = useState();
    const [payableModes, setPayableModes] = useState();
    const [supplierCommon, setSupplierCommon] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [totalValues, setTotalValues] = useState({
        totalAmount: 0
    });
    const [csvHeaders, SetCsvHeaders] = useState([]);
    const navigate = useNavigate();
    let encryptedgroupID = "";
    let encryptedfactoryID = ""

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            setSelectedRows(gridArray.map((row, index) => ({
                index,
                data: row,
                invoiceReference: row.invoiceReference,
                invoiceNumber: row.invoiceNumber
            })));
        } else {
            setSelectedRows([]);
        }
    };

    const handleRowCheckboxClick = (event, invoiceReference, invoiceNumber) => {
        const originalIndex = gridArray.findIndex(
            (row) => row.invoiceReference === invoiceReference
        );

        const selectedRowData = gridArray[originalIndex];
        if (event.target.checked) {
            setSelectedRows((prevSelectedRows) => [
                ...prevSelectedRows,
                { originalIndex, data: selectedRowData, invoiceReference: invoiceReference, invoiceNumber: invoiceNumber },
            ]);
        } else {
            setSelectedRows((prevSelectedRows) =>
                prevSelectedRows.filter((row) => row.invoiceReference !== invoiceReference)
            );
        }
    };
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupName: '',
        estateName: '',
        fromdate: '',
        todate: '',
        transactionModeName: '',
        supplierName: '',
        invoice: '',
        statusID: 0,
    });

    const dataIsLoaded = groups && factories;
    const handleProceed = () => {
        encryptedgroupID = btoa(generalJournalList.groupID.toString());
        encryptedfactoryID = btoa(generalJournalList.factoryID.toString());    
        sessionData();
        navigate('/app/invoicePayment/addedit/' + encryptedgroupID + "/" + encryptedfactoryID, {
            state: { selectedRows, generalJournalList }
        });
    }

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false,
        isAddEnabled: false,
    });

    useEffect(() => {
        getPermissions();
        trackPromise(
            getGroupsForDropdown(),
            GetAllPayableModes()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getFactoriesByGroupID()
        )
    }, [generalJournalList.groupID]);

    useEffect(() => {
        trackPromise(
            GetAllPayableModes(),
        )
    }, [generalJournalList.factoryID]);

    useEffect(() => {
        trackPromise(
            getSuppliersForDropDown()
        )
    }, [generalJournalList.groupID,generalJournalList.factoryID]);

    useEffect(() => {
        setGridArray([])
    }, [generalJournalList.groupID, generalJournalList.factoryID, generalJournalList.supplierID, generalJournalList.payableModeID, generalJournalList.fromDate, generalJournalList.toDate, generalJournalList.referenceNumber]);

    useEffect(() => {
        if (gridArray.length != 0) {
            calculateTotal();
        }
    }, [gridArray]);
    useEffect(() => {
        if (paymentIDData !== null) {
            trackPromise(handleSearch())
        }
    }, [paymentIDData]);

    useEffect(() => {
        sessionStorage.removeItem('invoicePayment-page-search-parameters-id');
    }, []);

    useEffect(() => {
        if (dataIsLoaded) {
            const storedSearchValues = sessionStorage.getItem('invoicePayment-page-search-parameters-id');
            if (storedSearchValues) {
                const parsedValues = JSON.parse(storedSearchValues);
                setSelectedSearchValues({
                    groupName: parsedValues.groupName || '',
                    estateName: parsedValues.estateName || '',
                    fromdate: parsedValues.fromdate || '',
                    todate: parsedValues.todate || '',


                });
            }
        }
    }, [dataIsLoaded]);

    async function getPermissions() {
        const IDdata = JSON.parse(sessionStorage.getItem('invoicePayment-page-search-parameters-id'));
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWINVOICEPAYMENT');

        if (isAuthorized === undefined) {
            navigate('/404');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');
        var isAddEnabled = permissions.find(p => p.permissionCode == 'ADDEDITINVOICEPAYMENT');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
            isAddEnabled: isAddEnabled !== undefined,

        });

        const isDefaultLoad = IDdata === null;
        if (isDefaultLoad) {
            setGeneralJournalList({
                ...generalJournalList,
                groupID: parseInt(tokenService.getGroupIDFromToken()),
                factoryID: parseInt(tokenService.getFactoryIDFromToken())
            })
        }
        else {
            setGeneralJournalList({
                ...generalJournalList,
                groupID: parseInt(IDdata.groupID),
                factoryID: parseInt(IDdata.factoryID),
                payableModeID: parseInt(IDdata.payableModeID),
                supplierID:parseInt(IDdata.supplierID),
                transactionTypeID: parseInt(IDdata.transactionTypeID),
                referenceNumber: IDdata.referenceNumber,
                fromDate: IDdata.fromDate,
                toDate: IDdata.toDate
            })

        }
        setpaymentIDdata(IDdata)
    }

    async function getFactoriesByGroupID() {
        const fac = await services.getFactoriesByGroupID(generalJournalList.groupID);
        setFactories(fac);
    }

    async function getGroupsForDropdown() {
        const groups = await services.getGroupsForDropdown();
        setGroups(groups);
    }

    async function GetAllPayableModes() {
        const payableModes = await services.GetAllPayableModes();
        setPayableModes(payableModes);
    }

    async function getSuppliersForDropDown() {
        const supplierResult = await services.getSuppliersForDropDown(generalJournalList.groupID, generalJournalList.factoryID);
        setSuppliers(supplierResult);
    }
    async function getSuppliersForDropDownAuto() {
        const supplierResult = await services.getSuppliersForDropDownAuto(generalJournalList.groupID, generalJournalList.factoryID);
        setSuppliersAuto(supplierResult);
    }

    function handleSearchDropdownChangeFieldsSupplier(data, e) {
        if (data === undefined || data === null) {
            setGeneralJournalList({
                ...generalJournalList,
                supplierID: '0'
            });
            return;
        } else {
            var valueV = data["supplierID"];
            var valueC = data["supplierCode"];
            setGeneralJournalList({
                ...generalJournalList,
                supplierID: valueV
            });

            if ((parseInt(valueV) > 0) && (valueC == 'COMMON')) {
                setSupplierCommon(true);
            } else {
                setSupplierCommon(false);
            }
        }
    }
    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function calculateTotal() {
        const totalAmount = gridArray.reduce((accumulator, current) => {
            const progressFraction = current.amount;
            return accumulator + progressFraction;
        }, 0);

        setTotalValues({
            ...totalValues,
            totalAmount: totalAmount
        });
    }

    function handleChange(e) {
        const target = e.target;
        const value = target.value
        setGeneralJournalList({
            ...generalJournalList,
            [e.target.name]: value
        });
    }

    const handleDateChange1 = (date) => {
        setGeneralJournalList({
            ...generalJournalList,
            fromDate: date
        });
    };

    const handleDateChange = (date) => {
        setGeneralJournalList({
            ...generalJournalList,
            toDate: date
        });
    };

    function cardTitle(titleName) {
        return (
            <Grid container spacing={1}>
                <Grid item md={10} xs={12}>
                    {titleName}
                </Grid>
                <Grid item md={2} xs={12}>

                </Grid>
            </Grid>
        )
    }

    function clearData() {
        setGeneralJournalList({
            ...generalJournalList,
            groupID: generalJournalList.groupID,
            factoryID: generalJournalList.factoryID,
            supplierID: 0,
            payableModeID: 0,
            transactionTypeID: 0,
            fromDate: new Date(),
            toDate: new Date()
        });
        setGridArray([]);
    }

    function sessionData() {
        let sessionModel = {
            groupID: generalJournalList.groupID,
            factoryID: generalJournalList.factoryID,
            payableModeID: generalJournalList.payableModeID,
            supplierID: generalJournalList.payableModeID === 2 ? 0 : generalJournalList.supplierID,
            transactionTypeID: generalJournalList.transactionTypeID,
            fromDate: generalJournalList.fromDate,
            toDate: generalJournalList.toDate,
        }
        sessionStorage.setItem(
            'invoicePayment-page-search-parameters-id', JSON.stringify(sessionModel)
        );
    }

    async function handleSearch() {

        let model = {
            groupID: generalJournalList.groupID,
            factoryID: generalJournalList.factoryID,
            supplierID: generalJournalList.supplierID,
            payableModeID: generalJournalList.payableModeID,
            transactionTypeID: generalJournalList.transactionTypeID,
            fromDate: generalJournalList.fromDate,
            toDate: generalJournalList.toDate,
        }

        getSelectedDropdownValuesForReport(model)
        const jList = await services.GetInvoicePaymentDetails(generalJournalList.groupID, generalJournalList.factoryID, generalJournalList.supplierID, generalJournalList.payableModeID, generalJournalList.transactionTypeID, generalJournalList.fromDate, generalJournalList.toDate);
        setGridArray(jList);
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        if (!dataIsLoaded) return;

        const updatedValues = {
            groupName: groups[searchForm.groupID] || '',
            estateName: factories[searchForm.factoryID] || '',
            fromDate: searchForm.fromDate || '',
            toDate: searchForm.toDate || '',
            supplierName: suppliers[searchForm.supplierID]?.name ?? '-',
        };

        setSelectedSearchValues(updatedValues);
        sessionStorage.setItem('Journal-listing-page-search-values', JSON.stringify(updatedValues));
    }

    async function createDataForExcel(array) {
        var res = [];

        if (array != null) {
            array.map(x => {

                const invoiceDate = new Date(x.invoiceDate);
                invoiceDate.setHours(0, 0, 0, 0);
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                const timeDifference = today.getTime() - invoiceDate.getTime();
                const pendingDays = Math.max(0, Math.floor(timeDifference / (1000 * 3600 * 24)));


                var vr = {
                    'Invoice Number': x.invoiceNumber,
                    'Reference Number': x.invoiceReference,
                    'Factory Name': x.estateName ? x.estateName : '-',
                    'Description': x.invoiceDescription ? x.invoiceDescription : '-',
                    'SupplierName': x.supplierName ? x.supplierName : '-',
                    'Invoice Date': x.invoiceDate ? x.invoiceDate.split('T')[0] : '-',
                    'Amount': x.amount ? x.amount.toFixed(2) : '-',
                    'Pending Days': isNaN(pendingDays) ? '-' : pendingDays,
                }
                res.push(vr);
            });

            res.push({});
            var vrTot = {
                'Invoice Date': "Total   ",
                'Amount': totalValues.totalAmount.toFixed(2),
            }
            res.push(vrTot);
            res.push({});

            var vr = {
                'Invoice Number': "Group : " + selectedSearchValues.groupName,
                'Reference Number': "Factory : " + selectedSearchValues.estateName,
            }
            res.push(vr);

            var vr1 = {
                'Invoice Number': "From : " + new Date(generalJournalList.fromDate).toISOString().split('T')[0],
                'Reference Number': "To : " + new Date(generalJournalList.toDate).toISOString().split('T')[0],
            }
            res.push(vr1);

            var vr = {
                'Invoice Number': "Supplier : " + array[0].supplierName,
            }
            res.push(vr);
        }
        return res;
    }

    async function createFile() {
        var file = await createDataForExcel(gridArray);
        var settings = {
            sheetName: 'Invoice Report',
            fileName: `Invoice Report - ${selectedSearchValues.groupName} - ${selectedSearchValues.estateName} `,
            writeOptions: {}
        }
        let keys = Object.keys(file[0])
        let tempcsvHeaders = csvHeaders;
        keys.map((sitem, i) => {
            tempcsvHeaders.push({ label: sitem, value: sitem })
        })
        let dataA = [
            {
                sheet: 'Invoice Report',
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }

    return (
        <Page
            className={classes.root}
            title="Invoice Payment"
        >
            <Container maxWidth={false}>
                <Formik
                    initialValues={{
                        groupID: generalJournalList.groupID,
                        factoryID: generalJournalList.factoryID,
                        supplierID: generalJournalList.supplierID,
                        payableModeID: generalJournalList.payableModeID,
                    }}
                    validationSchema={
                        Yup.object().shape({
                            groupID: Yup.number().required('Group is required').min("1", 'Select a group'),
                            factoryID: Yup.number().required('Factory is required').min("1", 'Select a factory'),
                            payableModeID: Yup.number().required('payableMode is required').min("1", 'Select a Payable mode'),
                            supplierID: Yup.number().required('Supplier is required').min(1, 'Select a supplier'),
                        })
                    }
                    onSubmit={() => trackPromise(handleSearch())}
                    enableReinitialize
                >
                    {({
                        errors,
                        handleBlur,
                        handleSubmit,
                        touched
                    }) => (
                        <form onSubmit={handleSubmit}>
                            <Box mt={0}>
                                <LoadingComponent />
                                <Card>
                                    <CardHeader
                                        title={cardTitle("Invoice Payment")}
                                    />
                                    <PerfectScrollbar>
                                        <Divider />
                                        <CardContent style={{ marginBottom: "2rem" }}>
                                            <Grid container spacing={3}>
                                                <Grid item md={3} xs={12}>
                                                    <InputLabel shrink id="groupID">Group  *</InputLabel>
                                                    <TextField select
                                                        error={Boolean(touched.groupID && errors.groupID)}
                                                        helperText={touched.groupID && errors.groupID}
                                                        fullWidth
                                                        name="groupID"
                                                        size='small'
                                                        onChange={(e) => handleChange(e)}
                                                        value={generalJournalList.groupID}
                                                        variant="outlined"
                                                        InputProps={{
                                                            readOnly: !permissionList.isGroupFilterEnabled ? true : false
                                                        }}
                                                    >
                                                        <MenuItem value="0">--Select Group--</MenuItem>
                                                        {generateDropDownMenu(groups)}
                                                    </TextField>
                                                </Grid>
                                                <Grid item md={3} xs={12}>
                                                    <InputLabel shrink id="factoryID">Factory *</InputLabel>
                                                    <TextField select
                                                        error={Boolean(touched.factoryID && errors.factoryID)}
                                                        helperText={touched.factoryID && errors.factoryID}
                                                        fullWidth
                                                        name="factoryID"
                                                        size='small'
                                                        onChange={(e) => handleChange(e)}
                                                        value={generalJournalList.factoryID}
                                                        variant="outlined"
                                                        id="factoryID"
                                                        InputProps={{
                                                            readOnly: !permissionList.isFactoryFilterEnabled ? true : false
                                                        }}
                                                    >
                                                        <MenuItem value="0">--Select Factory--</MenuItem>
                                                        {generateDropDownMenu(factories)}
                                                    </TextField>
                                                </Grid>
                                                <Grid item md={3} xs={12}>
                                                    <InputLabel shrink id="payableModeID">Transaction Mode *</InputLabel>
                                                    <TextField
                                                        select
                                                        error={Boolean(touched.payableModeID && errors.payableModeID)}
                                                        helperText={touched.payableModeID && errors.payableModeID}
                                                        fullWidth
                                                        name="payableModeID"
                                                        size="small"
                                                        onChange={(e) => handleChange(e)}
                                                        value={generalJournalList.payableModeID}
                                                        variant="outlined"
                                                        id="payableModeID"
                                                    >
                                                        <MenuItem value="0">--Select Payable Mode--</MenuItem>
                                                        {generateDropDownMenu(payableModes)}
                                                    </TextField>
                                                </Grid>
                                                <Grid item md={3} xs={12}>
                                                    <InputLabel shrink id="supplierID">Supplier *</InputLabel>
                                                    <TextField
                                                        select
                                                        error={Boolean(touched.supplierID && errors.supplierID)}
                                                        helperText={touched.supplierID && errors.supplierID}
                                                        fullWidth
                                                        name="supplierID"
                                                        size="small"
                                                        onChange={(e) => handleChange(e)}
                                                        value={generalJournalList.supplierID}
                                                        variant="outlined"
                                                        id="supplierID"
                                                    >
                                                        <MenuItem value="0">--Select Suppliers--</MenuItem>
                                                        {generateDropDownMenu(suppliers)}
                                                    </TextField>
                                                </Grid>
                                                
                                                <Grid item md={3} xs={12}>
                                                    <InputLabel shrink id="date" style={{ marginBottom: '-8px' }}>From Date</InputLabel>
                                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                        <KeyboardDatePicker
                                                            fullWidth
                                                            inputVariant="outlined"
                                                            format="dd/MM/yyyy"
                                                            margin="dense"
                                                            id="fromDate"
                                                            value={generalJournalList.fromDate}
                                                            onChange={(e) => {
                                                                handleDateChange1(e)
                                                            }}
                                                            KeyboardButtonProps={{
                                                                'aria-label': 'change date',
                                                            }}
                                                            inputProps={{
                                                                readOnly: true
                                                            }}
                                                            autoOk
                                                            maxDate={new Date()}
                                                        />
                                                    </MuiPickersUtilsProvider>
                                                </Grid>
                                                <Grid item md={3} xs={12}>
                                                    <InputLabel shrink id="date" style={{ marginBottom: '-8px' }}>To Date</InputLabel>
                                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                        <KeyboardDatePicker
                                                            fullWidth
                                                            inputVariant="outlined"
                                                            format="dd/MM/yyyy"
                                                            margin="dense"
                                                            id="toDate"
                                                            value={generalJournalList.toDate}
                                                            onChange={(e) => {
                                                                handleDateChange(e)
                                                            }}
                                                            KeyboardButtonProps={{
                                                                'aria-label': 'change date',
                                                            }}
                                                            inputProps={{
                                                                readOnly: true
                                                            }}
                                                            autoOk
                                                            maxDate={new Date()}
                                                        />
                                                    </MuiPickersUtilsProvider>
                                                </Grid>
                                            </Grid>
                                            <Box display="flex" flexDirection="row-reverse" p={2} >
                                                <Button
                                                    color="primary"
                                                    type="submit"
                                                    variant="contained"
                                                >
                                                    Search
                                                </Button>
                                                <div>&nbsp;</div>
                                                <Button
                                                    color="primary"
                                                    type="reset"
                                                    variant="outlined"
                                                    onClick={() => clearData()}
                                                >
                                                    Clear
                                                </Button>
                                            </Box>
                                        </CardContent>
                                        {gridArray.length > 0 ? (
                                            <TableContainer style={{ maxHeight: '550px', overflowY: 'auto' }}>
                                                <Table style={{ width: '100%' }} aria-label="bank reconciliation table">
                                                    <TableHead style={{ position: "sticky", top: 0, zIndex: 1000, background: "white" }}>
                                                        <TableRow>
                                                            <TableCell align="left"><b>Invoice Number</b></TableCell>
                                                            <TableCell align="left"><b>Reference Number</b></TableCell>
                                                            <TableCell align="left"><b>Factory</b></TableCell>
                                                            <TableCell align="left"><b>Invoice Description</b></TableCell>
                                                            <TableCell align="left"><b>Invoice Date</b></TableCell>
                                                            <TableCell align="right"><b>Amount</b></TableCell>
                                                            <TableCell align="left"><b>Pending Days</b></TableCell>
                                                            <TableCell align="center">
                                                                <b>Select All</b>
                                                                <Checkbox
                                                                    indeterminate={selectedRows.length > 0 && selectedRows.length < gridArray.length}
                                                                    checked={selectedRows.length === gridArray.length}
                                                                    onChange={handleSelectAllClick}
                                                                />
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {gridArray.map((row, index) => {
                                                            const invoiceDate = new Date(row.invoiceDate);
                                                            invoiceDate.setHours(0, 0, 0, 0);
                                                            const today = new Date();
                                                            today.setHours(0, 0, 0, 0);
                                                            const timeDifference = today.getTime() - invoiceDate.getTime();
                                                            const pendingDays = Math.max(0, Math.floor(timeDifference / (1000 * 3600 * 24)));

                                                            return (
                                                                <TableRow key={index}>
                                                                    <TableCell align="left" style={{ height: '5%' }}>{row.invoiceNumber}</TableCell>
                                                                    <TableCell align="left" style={{ height: '5%' }}>{row.invoiceReference}</TableCell>
                                                                    <TableCell align="left" style={{ height: '5%' }}>{row.estateName}</TableCell>
                                                                    <TableCell align="left" style={{ height: '5%' }}>{row.invoiceDescription ? row.invoiceDescription : '-'}</TableCell>
                                                                    <TableCell align="left" style={{ height: '5%' }}>{row.invoiceDate ? row.invoiceDate.split('T')[0] : ''}</TableCell>
                                                                    <TableCell align="right" style={{ height: '5%' }}>
                                                                        {parseFloat(row.amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                    </TableCell>
                                                                    <TableCell align="left" style={{ height: '5%' }}>{isNaN(pendingDays) ? '-' : pendingDays}</TableCell>
                                                                    <TableCell align="center" style={{ height: '5%' }}>
                                                                        <Checkbox
                                                                            checked={selectedRows.some((selectedRow) => selectedRow.invoiceReference === row.invoiceReference)}
                                                                            onChange={(event) => handleRowCheckboxClick(event, row.invoiceReference, row.invoiceNumber)}
                                                                        />
                                                                    </TableCell>
                                                                </TableRow>
                                                            );
                                                        })}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        ) : (
                                            <Typography align="center" variant="h6" style={{ margin: "1rem 0" }}>
                                                No data available
                                            </Typography>
                                        )}
                                        {selectedRows.length > 0 && gridArray.length > 0 && (
                                            <Box display="flex" justifyContent="flex-end" p={2}>
                                                <Button
                                                    className={classes.btnCalculate}
                                                    color="primary"
                                                    variant="contained"
                                                    size="small"
                                                    onClick={handleProceed}
                                                >
                                                    Proceed
                                                </Button>
                                            </Box>
                                        )}
                                        {gridArray.length > 0 ?
                                            <Box display="flex" justifyContent="flex-end" p={2}>
                                                <Button
                                                    color="primary"
                                                    id="btnRecord"
                                                    type="submit"
                                                    variant="contained"
                                                    style={{ marginRight: '1rem', backgroundColor: 'green', color: 'white' }}
                                                    className={classes.colorRecord}
                                                    onClick={createFile}
                                                >
                                                    EXCEL
                                                </Button>
                                            </Box>
                                            : null}
                                    </PerfectScrollbar>
                                </Card>
                            </Box>
                        </form>
                    )}
                </Formik>
            </Container>
        </Page>
    );
};

